module.exports = __webpack_public_path__ + "img/img-860a1f.png";